import { render } from "./FieldOptionRemapDialog.vue?vue&type=template&id=4a4453b8&scoped=true"
import script from "./FieldOptionRemapDialog.vue?vue&type=script&lang=js"
export * from "./FieldOptionRemapDialog.vue?vue&type=script&lang=js"

import "./FieldOptionRemapDialog.vue?vue&type=style&index=0&id=4a4453b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4453b8"]])

export default __exports__